import ReportService from '@/src/services/report'

const reportRenovacaoEspecificaMixin = {
    data(){
        return {
            reportFields:[
                {
                    key: 'cliente',
                    label: 'Cliente',
                    field: 'cliente'
                },
                {
                    key: 'telefone',
                    label: 'Telefone',
                    field: 'telefone'
                },
                {
                    key: 'dataVencimento',
                    label: 'Data de vencimento',
                    field: 'dataVencimento'
                },
                {
                    key: 'plano',
                    label: 'Plano',
                    field: 'plano'
                },
                {
                    key: 'quantidade_de_uso',
                    label: 'Quantidade de uso',
                    field: 'quantidade_de_uso'
                }, 
                {
                    key: 'situacao',
                    label: 'Situação',
                    field: 'situacao'
                }, 
            ]

        }
    },
    methods: {

        async specificRenewal(unidade, vendedor, periodo) {
            const renewal = await ReportService.specificRenewal(unidade, vendedor, periodo)
            return renewal
        },

        async specificRenewalByDate(data_inicial, data_final) {
            const renewal = await ReportService.specificRenewalByDate(data_inicial, data_final)
            return renewal
        },
    }
}

export default reportRenovacaoEspecificaMixin;
